/* Theme initialisation.
   This bundle is evaluated once per session (data-turbo-eval="false").
   Per-page DOM bindings live in initPage() and re-run on every Turbo
   visit; window/document-level listeners are registered exactly once. */

/* Mobile menu burger toggle */
function initBurger() {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation && navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
}

/* Add lightbox to gallery images */
function initLightbox() {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
}

/* Responsive video in post content */
function initVideos() {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
}

/* Infinite scroll pagination */
function initPagination() {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
}

/* Responsive HTML table */
function initTables() {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
}

/* Wrap trailing domain text in Sources lists */
function initSources() {
    const heading = document.querySelector('.gh-content h2#sources, .gh-content h2[id="sources"]');
    if (!heading) return;

    const list = heading.nextElementSibling;
    if (!list || list.tagName !== 'UL') return;

    list.querySelectorAll('li').forEach(function (item) {
        if (item.querySelector('.source-domain')) return;

        const link = item.querySelector('a');
        if (!link) return;

        const trailing = [];
        let node = link.nextSibling;

        while (node) {
            const next = node.nextSibling;
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
                trailing.push(node.textContent.trim());
                item.removeChild(node);
            }
            node = next;
        }

        if (!trailing.length) return;

        const domain = document.createElement('span');
        domain.className = 'source-domain';
        domain.textContent = trailing.join(' ');
        item.appendChild(domain);
    });
}

/* Color scheme toggle */
const colorScheme = (function () {
    const STORAGE_KEY = 'color-scheme-preference';
    const root = document.documentElement;
    const themeDefault = (root.dataset.themeDefault || 'system').toLowerCase();

    function getSystemScheme() {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    function resolveScheme(preference) {
        if (preference === 'system') {
            return getSystemScheme();
        }
        return preference;
    }

    function applyScheme(preference) {
        const effective = resolveScheme(preference);
        root.dataset.colorScheme = effective;
        root.dataset.colorPreference = preference;
        updateContrastClass(effective);
        updateToggleState(preference, effective);
    }

    function updateContrastClass(scheme) {
        root.classList.remove('has-light-text', 'has-dark-text');
        root.classList.add(scheme === 'dark' ? 'has-light-text' : 'has-dark-text');
    }

    function updateToggleState(preference, effective) {
        document.querySelectorAll('.gh-theme-toggle').forEach(function (toggle) {
            toggle.dataset.preference = preference;
            toggle.setAttribute(
                'aria-label',
                preference === 'system'
                    ? 'Color scheme: System (' + effective + ')'
                    : 'Color scheme: ' + preference.charAt(0).toUpperCase() + preference.slice(1)
            );
        });
    }

    function getInitialPreference() {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'light' || stored === 'dark' || stored === 'system') {
            return stored;
        }
        return themeDefault;
    }

    function cyclePreference(current) {
        if (current === 'light') return 'dark';
        if (current === 'dark') return 'system';
        return 'light';
    }

    /* Registered once; system preference changes are page-independent */
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
        if ((root.dataset.colorPreference || getInitialPreference()) === 'system') {
            applyScheme('system');
        }
    });

    /* Toggle buttons are inside the swapped body, so re-bind per page */
    return function initColorScheme() {
        const preference = root.dataset.colorPreference || getInitialPreference();
        applyScheme(preference);

        document.querySelectorAll('.gh-theme-toggle').forEach(function (toggle) {
            toggle.addEventListener('click', function () {
                const next = cyclePreference(root.dataset.colorPreference || preference);
                if (next === themeDefault) {
                    localStorage.removeItem(STORAGE_KEY);
                } else {
                    localStorage.setItem(STORAGE_KEY, next);
                }
                applyScheme(next);
            });
        });
    };
})();

function initPage() {
    /* Reset scroll lock in case navigation happened with the menu open */
    document.documentElement.style.overflowY = null;

    initBurger();
    initLightbox();
    initVideos();
    dropdown();
    initPagination();
    initTables();
    initSources();
    colorScheme();
}

(function () {
    let started = false;

    function start() {
        if (started) return;
        started = true;

        if (window.Turbo) {
            /* Only intercept link navigation; Ghost's portal handles member
               forms itself and Turbo must not compete with it */
            window.Turbo.setFormMode('off');
        }

        initPage();
    }

    /* Fires on the initial load and on every soft navigation */
    document.addEventListener('turbo:load', function () {
        if (!started) {
            start();
        } else {
            initPage();
        }
    });

    /* Fallback if Turbo failed to load: init once on DOM ready */
    document.addEventListener('DOMContentLoaded', function () {
        if (!window.Turbo) {
            start();
        }
    });
})();
